import { defineMessages } from "react-intl";

const PREFIX = "Favourites.FavouritesSettings.Actions";
export const messages = defineMessages({
  save: {
    id: `${PREFIX}.save`,
    defaultMessage: "Save",
  },
  cancel: {
    id: `${PREFIX}.cancel`,
    defaultMessage: "Cancel",
  },
  delete: {
    id: `${PREFIX}.delete`,
    defaultMessage: "Remove",
  },
});
